import formatMessage from './../i18n/formatMessage';

export default [
  { id: 0, name: formatMessage('acompanhamentoProdutor.sementes') },
  { id: 1, name: formatMessage('acompanhamentoProdutor.toneladas') },
  { id: 2, name: formatMessage('acompanhamentoProdutor.mudas') }
];
